/**
 * Registro das 30 páginas no escopo da migração (00-diagnostico §10.2–10.4),
 * mais as páginas novas, sem equivalente no Streamlit.
 *
 * `slugLegado` é o `url_path` que o Streamlit usava (`/?page=<slug>`); não editar à mão:
 * é a chave de `COMPONENTES` e o que redireciona os links antigos para a rota React
 * `/<secaoSlug>/<pagina>`. O Streamlit foi desligado em 2026-10 (tag `legado-final`).
 */

export interface Pagina {
  secao: string;
  secaoSlug: string;
  pagina: string;
  titulo: string;
  slugLegado: string;
}

export const PAGINAS: readonly Pagina[] = [
  {
    secao: 'Acompanhamentos Periódicos',
    secaoSlug: 'acompanhamentos-periodicos',
    pagina: 'brasil-asset-iii',
    titulo: 'Brasil Asset III',
    slugLegado: 'acompanhamentos-periodicos_brasil-asset-iii',
  },
  {
    secao: 'Acompanhamentos Periódicos',
    secaoSlug: 'acompanhamentos-periodicos',
    pagina: 'capital-market-assumptions',
    titulo: 'Capital Market Assumptions',
    slugLegado: 'acompanhamentos-periodicos_capital-market-assumptions',
  },
  {
    secao: 'Acompanhamentos Periódicos',
    secaoSlug: 'acompanhamentos-periodicos',
    pagina: 'comite-de-investimentos',
    titulo: 'Comitê de Investimentos',
    slugLegado: 'acompanhamentos-periodicos_comite-de-investimentos',
  },
  {
    secao: 'Acompanhamentos Periódicos',
    secaoSlug: 'acompanhamentos-periodicos',
    pagina: 'projecoes-anbima',
    titulo: 'Projeções ANBIMA',
    slugLegado: 'acompanhamentos-periodicos_projecoes-anbima',
  },
  {
    secao: 'Crédito Privado',
    secaoSlug: 'credito-privado',
    pagina: 'precificacao',
    titulo: 'Precificação',
    slugLegado: 'credito-privado_precificacao',
  },
  {
    secao: 'Crédito Privado',
    secaoSlug: 'credito-privado',
    pagina: 'spreads-de-credito',
    titulo: 'Spreads de Crédito',
    slugLegado: 'credito-privado_spreads-de-credito',
  },
  {
    secao: 'Crédito Privado',
    secaoSlug: 'credito-privado',
    pagina: 'spreads-por-emissor',
    titulo: 'Spreads por Emissor',
    slugLegado: 'credito-privado_spreads-por-emissor',
  },
  {
    secao: 'Equities',
    secaoSlug: 'equities',
    pagina: 'b3-fluxo-de-investidores',
    titulo: 'B3 · Fluxo de Investidores',
    slugLegado: 'equities_b3-fluxo-de-investidores',
  },
  {
    secao: 'Equities',
    secaoSlug: 'equities',
    pagina: 'market-breadth',
    titulo: 'Market Breadth',
    slugLegado: 'equities_market-breadth',
  },
  {
    secao: 'Equities',
    secaoSlug: 'equities',
    pagina: 'screener',
    titulo: 'Screener',
    slugLegado: 'equities_screener',
  },
  {
    secao: 'Equities',
    secaoSlug: 'equities',
    pagina: 'valuation',
    titulo: 'Valuation',
    slugLegado: 'equities_valuation',
  },
  {
    secao: 'Análise Quantitativa',
    secaoSlug: 'analise-quantitativa',
    pagina: 'factor-investing',
    titulo: 'Factor Investing',
    slugLegado: 'analise-quantitativa_factor-investing',
  },
  {
    secao: 'Análise Quantitativa',
    secaoSlug: 'analise-quantitativa',
    pagina: 'portfolio-backtester',
    titulo: 'Portfolio Backtester',
    slugLegado: 'analise-quantitativa_portfolio-backtester',
  },
  {
    secao: 'Fundos',
    secaoSlug: 'fundos',
    pagina: 'peer-group',
    titulo: 'Peer Group',
    slugLegado: 'fundos_peer-group',
  },
  {
    secao: 'Fundos',
    secaoSlug: 'fundos',
    pagina: 'selecao-scorecard',
    titulo: 'Seleção & Scorecard',
    slugLegado: 'fundos_selecao-scorecard',
  },
  {
    secao: 'Carteiras Administradas',
    secaoSlug: 'carteiras-administradas',
    pagina: 'alocacao-rbs',
    titulo: 'Alocação · RBS',
    slugLegado: 'carteiras-administradas_alocacao-rbs',
  },
  {
    secao: 'Carteiras Administradas',
    secaoSlug: 'carteiras-administradas',
    pagina: 'carteiras-modelo-portfolio',
    titulo: 'Carteiras Modelo · Portfolio',
    slugLegado: 'carteiras-administradas_carteiras-modelo-portfolio',
  },
  {
    secao: 'Carteiras Administradas',
    secaoSlug: 'carteiras-administradas',
    pagina: 'carteiras-modelo-rebalanceador',
    titulo: 'Carteiras Modelo · Rebalanceador',
    slugLegado: 'carteiras-administradas_carteiras-modelo-rebalanceador',
  },
  {
    secao: 'Carteiras Administradas',
    secaoSlug: 'carteiras-administradas',
    pagina: 'comparador',
    titulo: 'Comparador',
    slugLegado: 'carteiras-administradas_comparador',
  },
  {
    secao: 'Carteiras Administradas',
    secaoSlug: 'carteiras-administradas',
    pagina: 'controle-de-posicoes',
    titulo: 'Portfolio Analytics',
    slugLegado: 'carteiras-administradas_controle-de-posicoes',
  },
  {
    secao: 'Carteiras Administradas',
    secaoSlug: 'carteiras-administradas',
    pagina: 'controle-de-vencimentos',
    titulo: 'Controle de Vencimentos',
    slugLegado: 'carteiras-administradas_controle-de-vencimentos',
  },
  {
    secao: 'Carteiras Administradas',
    secaoSlug: 'carteiras-administradas',
    pagina: 'distribuicao',
    titulo: 'Distribuição',
    slugLegado: 'carteiras-administradas_distribuicao',
  },
  {
    secao: 'Carteiras Administradas',
    secaoSlug: 'carteiras-administradas',
    pagina: 'monitor-fgc',
    titulo: 'Monitor FGC',
    slugLegado: 'carteiras-administradas_monitor-fgc',
  },
  {
    secao: 'Carteiras Administradas',
    secaoSlug: 'carteiras-administradas',
    pagina: 'operacoes-em-lote',
    titulo: 'Operações em Lote',
    slugLegado: 'carteiras-administradas_operacoes-em-lote',
  },
  {
    secao: 'Carteiras Administradas',
    secaoSlug: 'carteiras-administradas',
    pagina: 'otimizador-de-alocacao',
    titulo: 'Otimizador de Alocação',
    slugLegado: 'carteiras-administradas_otimizador-de-alocacao',
  },
  {
    secao: 'Carteiras Administradas',
    secaoSlug: 'carteiras-administradas',
    pagina: 'planejamento-financeiro',
    titulo: 'Planejamento Financeiro',
    slugLegado: 'carteiras-administradas_planejamento-financeiro',
  },
  {
    secao: 'Carteiras Administradas',
    secaoSlug: 'carteiras-administradas',
    pagina: 'xbridge',
    titulo: 'XBridge',
    slugLegado: 'carteiras-administradas_xbridge',
  },
  {
    secao: 'Carteiras Administradas',
    secaoSlug: 'carteiras-administradas',
    pagina: 'performance',
    titulo: 'Performance',
    slugLegado: 'carteiras-administradas_performance',
  },
  {
    secao: 'Utilitários',
    secaoSlug: 'utilitarios',
    pagina: 'calendario-economico',
    titulo: 'Calendário Econômico',
    slugLegado: 'utilitarios_calendario-economico',
  },
  {
    secao: 'Utilitários',
    secaoSlug: 'utilitarios',
    pagina: 'extracao-de-dados',
    titulo: 'Extração de Dados',
    slugLegado: 'utilitarios_extracao-de-dados',
  },
  {
    secao: 'Utilitários',
    secaoSlug: 'utilitarios',
    pagina: 'gerador-de-graficos',
    titulo: 'Gerador de Gráficos',
    slugLegado: 'utilitarios_gerador-de-graficos',
  },
  {
    secao: 'Utilitários',
    secaoSlug: 'utilitarios',
    pagina: 'hora-360',
    titulo: 'Hora 360',
    slugLegado: 'utilitarios_hora-360',
  },
];

export function rotaNova(p: Pagina): string {
  return `/${p.secaoSlug}/${p.pagina}`;
}

/** Páginas agrupadas por seção, na ordem do menu atual. */
export function porSecao(paginas: readonly Pagina[] = PAGINAS): [string, Pagina[]][] {
  const grupos = new Map<string, Pagina[]>();
  for (const p of paginas) {
    grupos.set(p.secao, [...(grupos.get(p.secao) ?? []), p]);
  }
  return [...grupos.entries()];
}

/**
 * Compatibilidade com links salvos do Streamlit (`/?page=<slug>`): devolve a rota nova,
 * ou `null` se não houver `page` ou o slug for de uma página que não existe mais (fica
 * na Home).
 */
export function redirecionamentoLegado(
  search: string,
  paginas: readonly Pagina[] = PAGINAS,
): string | null {
  const slug = new URLSearchParams(search).get('page');
  if (!slug) return null;
  const pagina = paginas.find((p) => p.slugLegado === slug);
  return pagina ? rotaNova(pagina) : null;
}
